(function () {
	'use strict';

	angular.module('mx.components').directive('mxTransclude', function mxTranscludeDirective() {
		return {
			restrict: 'A',
			compile: function (tElem, tAttrs, transclude) {
				return function (scope, elem) {
					transclude(scope, function (clone) {
						elem.append(clone);
					});
				};
			},
		};
	});
})();
